import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigLoginService } from '../auth/config-login.service';

@Injectable({
  providedIn: 'root'
})
export class LandingPageGuard  {

  constructor(
    private router: Router,
    private configLoginService: ConfigLoginService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const loginType = this.configLoginService.getLoginType();

    if (loginType === 'login') {
      return true;
    } else if (loginType === 'loginDav') {
      return this.router.createUrlTree(['/auth/loginDav']);
    } else {
      return this.router.createUrlTree(['/404NotFound']);
    }

  }

}
